(function () {
  'use strict';

  var FITMENT = {
    '1 Series': {
      'Hatchback': [
        { chassis: 'E87', label: 'E87', years: [2004, 2011], trims: ['116i', '118i', '120i', '130i'] },
        { chassis: 'F20', label: 'F20', years: [2012, 2019], trims: ['116i', '118i', '120i', '125i', 'M135i', 'M140i'] }
      ],
      'Coupe': [
        { chassis: 'E82', label: 'E82', years: [2008, 2013], trims: ['128i', '135i', '1M Coupe'] }
      ]
    },
    '2 Series': {
      'Coupe': [
        { chassis: 'F22', label: 'F22', years: [2014, 2021], trims: ['220i', '228i', '228i xDrive', '230i', '235i xDrive', 'M240i', 'M240i xDrive'] },
        { chassis: 'F87', label: 'F87 M2', years: [2016, 2021], trims: ['M2', 'M2 Competition', 'M2 CS'] },
        { chassis: 'G42', label: 'G42', years: [2022, 2025], trims: ['220i', '230i', 'M240i xDrive'] },
        { chassis: 'G87', label: 'G87 M2', years: [2023, 2025], trims: ['M2', 'M2 Competition'] }
      ],
      'Convertible': [
        { chassis: 'F23', label: 'F23', years: [2015, 2021], trims: ['228i', '228i xDrive', '230i', '235i xDrive', 'M240i'] }
      ],
      'Gran Coupe': [
        { chassis: 'F44', label: 'F44', years: [2020, 2025], trims: ['218i', '220i', '228i xDrive', 'M235i xDrive'] }
      ]
    },
    '3 Series': {
      'Sedan': [
        { chassis: 'E90', label: 'E90', years: [2006, 2011], trims: ['316i', '320i', '323i', '325i', '328i', '328xi', '330i', '330xi', '335i', '335xi'] },
        { chassis: 'F30', label: 'F30', years: [2012, 2018], trims: ['316i', '320i', '320i xDrive', '323i', '328i', '328i xDrive', '328d', '328d xDrive', '330i', '330i xDrive', '330e', '335i', '335i xDrive', '340i', '340i xDrive'] },
        { chassis: 'F80', label: 'F80 M3', years: [2014, 2018], trims: ['M3', 'M3 CS'] },
        { chassis: 'G20', label: 'G20', years: [2019, 2025], trims: ['320i', '330i', '330i xDrive', '330e', '330e xDrive', 'M340i', 'M340i xDrive'] },
        { chassis: 'G80', label: 'G80 M3', years: [2021, 2025], trims: ['M3', 'M3 Competition', 'M3 CS', 'M3 CSL'] }
      ],
      'Touring': [
        { chassis: 'E91', label: 'E91', years: [2006, 2012], trims: ['320i', '325i', '328i', '330i', '335i'] },
        { chassis: 'F31', label: 'F31', years: [2012, 2018], trims: ['316i', '320i', '320i xDrive', '328i', '328i xDrive', '328d', '330i', '335i'] },
        { chassis: 'G21', label: 'G21', years: [2020, 2025], trims: ['320i', '330i', 'M340i xDrive'] }
      ],
      'Coupe': [
        { chassis: 'E92', label: 'E92', years: [2007, 2013], trims: ['323i', '325i', '328i', '328xi', '330i', '335i', '335xi'] },
        { chassis: 'E92 M3', label: 'E92 M3', years: [2008, 2013], trims: ['M3', 'M3 CS'] }
      ],
      'Convertible': [
        { chassis: 'E93', label: 'E93', years: [2007, 2013], trims: ['325i', '328i', '335i'] },
        { chassis: 'E93 M3', label: 'E93 M3', years: [2008, 2013], trims: ['M3'] }
      ],
      'Gran Turismo': [
        { chassis: 'F34', label: 'F34', years: [2013, 2019], trims: ['328i', '328i xDrive', '335i', '335i xDrive', '340i', '340i xDrive'] }
      ]
    },
    '4 Series': {
      'Coupe': [
        { chassis: 'F32', label: 'F32', years: [2014, 2020], trims: ['420i', '428i', '428i xDrive', '430i', '430i xDrive', '435i', '435i xDrive', '440i', '440i xDrive'] },
        { chassis: 'F82', label: 'F82 M4', years: [2015, 2020], trims: ['M4', 'M4 CS', 'M4 GTS'] },
        { chassis: 'G22', label: 'G22', years: [2021, 2025], trims: ['420i', '430i', '430i xDrive', '440i xDrive'] },
        { chassis: 'G82', label: 'G82 M4', years: [2021, 2025], trims: ['M4', 'M4 Competition', 'M4 CS', 'M4 CSL'] }
      ],
      'Convertible': [
        { chassis: 'F33', label: 'F33', years: [2014, 2020], trims: ['428i', '428i xDrive', '430i', '435i', '440i'] },
        { chassis: 'F83', label: 'F83 M4', years: [2015, 2020], trims: ['M4'] },
        { chassis: 'G23', label: 'G23', years: [2021, 2025], trims: ['430i', '440i xDrive'] },
        { chassis: 'G83', label: 'G83 M4', years: [2021, 2025], trims: ['M4', 'M4 Competition'] }
      ],
      'Gran Coupe': [
        { chassis: 'F36', label: 'F36', years: [2014, 2020], trims: ['420i', '428i', '428i xDrive', '430i', '440i', '440i xDrive'] },
        { chassis: 'G26', label: 'G26', years: [2021, 2025], trims: ['420i', '430i xDrive', '440i xDrive'] }
      ]
    },
    '5 Series': {
      'Sedan': [
        { chassis: 'E60', label: 'E60', years: [2004, 2010], trims: ['520i', '523i', '525i', '525xi', '528i', '530i', '535i', '545i', '550i'] },
        { chassis: 'F10', label: 'F10', years: [2011, 2016], trims: ['520i', '525i', '528i', '528i xDrive', '530i', '535i', '535i xDrive', '550i', '550i xDrive', 'ActiveHybrid 5'] },
        { chassis: 'G30', label: 'G30', years: [2017, 2023], trims: ['520i', '530i', '530i xDrive', '530e', '530e xDrive', '540i', '540i xDrive', '545e xDrive'] },
        { chassis: 'F90', label: 'F90 M5', years: [2018, 2024], trims: ['M5', 'M5 Competition', 'M5 CS'] }
      ],
      'Touring': [
        { chassis: 'E61', label: 'E61', years: [2004, 2010], trims: ['520i', '523i', '525i', '528i', '530i', '535i', '550i'] },
        { chassis: 'F11', label: 'F11', years: [2011, 2016], trims: ['520i', '528i', '535i', '535i xDrive', '550i'] },
        { chassis: 'G31', label: 'G31', years: [2017, 2023], trims: ['520i', '530i', '540i'] }
      ],
      'Gran Turismo': [
        { chassis: 'F07', label: 'F07', years: [2010, 2017], trims: ['535i', '535i xDrive', '550i', '550i xDrive'] }
      ]
    },
    '6 Series': {
      'Coupe': [
        { chassis: 'E63', label: 'E63', years: [2004, 2010], trims: ['630i', '645Ci', '650i', 'M6'] },
        { chassis: 'F13', label: 'F13', years: [2012, 2018], trims: ['640i', '640i xDrive', '650i', '650i xDrive', 'M6'] }
      ],
      'Convertible': [
        { chassis: 'E64', label: 'E64', years: [2004, 2010], trims: ['630i', '645Ci', '650i', 'M6'] },
        { chassis: 'F12', label: 'F12', years: [2012, 2018], trims: ['640i', '640i xDrive', '650i', 'M6'] }
      ],
      'Gran Coupe': [
        { chassis: 'F06', label: 'F06', years: [2013, 2019], trims: ['640i', '640i xDrive', '650i', '650i xDrive', 'M6 Gran Coupe'] }
      ]
    },
    '7 Series': {
      'Sedan': [
        { chassis: 'E65', label: 'E65 - SWB', years: [2002, 2008], trims: ['730i', '740i', '745i', '750i', '760i'] },
        { chassis: 'E66', label: 'E66 - LWB', years: [2002, 2008], trims: ['730Li', '740Li', '745Li', '750Li', '760Li', 'Alpina B7'] },
        { chassis: 'F01', label: 'F01 - SWB', years: [2009, 2015], trims: ['730i', '740i', '750i', '760i', 'ActiveHybrid 7', 'Alpina B7'] },
        { chassis: 'F02', label: 'F02 - LWB', years: [2009, 2015], trims: ['730Li', '740Li', '750Li', '760Li', 'Alpina B7L'] },
        { chassis: 'G11', label: 'G11 - SWB', years: [2016, 2022], trims: ['730i', '740i', '740e xDrive', '745e xDrive', '750i xDrive', '760i xDrive', 'M760i xDrive', 'Alpina B7'] },
        { chassis: 'G12', label: 'G12 - LWB', years: [2016, 2022], trims: ['730Li', '740Li', '740Le xDrive', '745Le xDrive', '750Li xDrive', 'M760Li xDrive', 'Alpina B7L'] }
      ]
    },
    '8 Series': {
      'Coupe': [
        { chassis: 'G15', label: 'G15', years: [2019, 2025], trims: ['840i', '840i xDrive', 'M850i xDrive'] },
        { chassis: 'G15 M8', label: 'G15 M8', years: [2020, 2025], trims: ['M8', 'M8 Competition'] }
      ],
      'Convertible': [
        { chassis: 'G14', label: 'G14', years: [2019, 2025], trims: ['840i xDrive', 'M850i xDrive'] },
        { chassis: 'G14 M8', label: 'G14 M8', years: [2020, 2025], trims: ['M8', 'M8 Competition'] }
      ],
      'Gran Coupe': [
        { chassis: 'G16', label: 'G16', years: [2020, 2025], trims: ['840i xDrive', 'M850i xDrive'] },
        { chassis: 'G16 M8', label: 'G16 M8', years: [2020, 2025], trims: ['M8', 'M8 Competition'] }
      ]
    },
    'X1': {
      'SUV': [
        { chassis: 'E84', label: 'E84', years: [2010, 2015], trims: ['sDrive20i', 'sDrive28i', 'xDrive20i', 'xDrive28i', 'xDrive35i'] },
        { chassis: 'F48', label: 'F48', years: [2016, 2022], trims: ['sDrive20i', 'sDrive28i', 'xDrive20i', 'xDrive28i', 'xDrive30i', 'M35i xDrive'] },
        { chassis: 'U11', label: 'U11', years: [2023, 2025], trims: ['xDrive23i', 'M35i xDrive'] }
      ]
    },
    'X2': {
      'SUV': [
        { chassis: 'F39', label: 'F39', years: [2018, 2023], trims: ['sDrive28i', 'xDrive28i', 'xDrive30i', 'M35i xDrive'] }
      ]
    },
    'X3': {
      'SUV': [
        { chassis: 'E83', label: 'E83', years: [2004, 2010], trims: ['2.5i', '3.0i', '3.0si', 'xDrive30d'] },
        { chassis: 'F25', label: 'F25', years: [2011, 2017], trims: ['xDrive20i', 'xDrive28i', 'xDrive35i', 'xDrive28d', 'M40i'] },
        { chassis: 'G01', label: 'G01', years: [2018, 2025], trims: ['sDrive30i', 'xDrive20i', 'xDrive30i', 'xDrive30e', 'M40i xDrive'] }
      ]
    },
    'X4': {
      'SUV': [
        { chassis: 'F26', label: 'F26', years: [2015, 2018], trims: ['xDrive28i', 'xDrive35i', 'M40i'] },
        { chassis: 'G02', label: 'G02', years: [2019, 2025], trims: ['xDrive20i', 'sDrive30i', 'xDrive30i', 'M40i xDrive'] }
      ]
    },
    'X5': {
      'SUV': [
        { chassis: 'E53', label: 'E53', years: [2000, 2006], trims: ['3.0i', '4.4i', '4.6is', '4.8is'] },
        { chassis: 'E70', label: 'E70', years: [2007, 2013], trims: ['xDrive30i', 'xDrive35i', 'xDrive48i', 'xDrive50i', 'ActiveHybrid X5'] },
        { chassis: 'F15', label: 'F15', years: [2014, 2018], trims: ['sDrive35i', 'xDrive35i', 'xDrive35d', 'xDrive40e', 'xDrive50i'] },
        { chassis: 'F85', label: 'F85 X5 M', years: [2015, 2018], trims: ['X5 M', 'X5 M Competition'] },
        { chassis: 'G05', label: 'G05', years: [2019, 2025], trims: ['xDrive40i', 'xDrive45e', 'xDrive50i', 'M50i', 'M60i xDrive'] },
        { chassis: 'F95', label: 'F95 X5 M', years: [2020, 2025], trims: ['X5 M', 'X5 M Competition'] }
      ]
    },
    'X6': {
      'SUV': [
        { chassis: 'E71', label: 'E71', years: [2008, 2014], trims: ['xDrive35i', 'xDrive50i', 'ActiveHybrid X6'] },
        { chassis: 'F16', label: 'F16', years: [2015, 2019], trims: ['xDrive35i', 'xDrive50i', 'M50d'] },
        { chassis: 'F86', label: 'F86 X6 M', years: [2015, 2019], trims: ['X6 M', 'X6 M Competition'] },
        { chassis: 'G06', label: 'G06', years: [2020, 2025], trims: ['xDrive40i', 'xDrive50i', 'M50i', 'M60i xDrive'] },
        { chassis: 'F96', label: 'F96 X6 M', years: [2020, 2022], trims: ['X6 M', 'X6 M Competition'] }
      ]
    },
    'X7': {
      'SUV': [
        { chassis: 'G07', label: 'G07', years: [2019, 2025], trims: ['xDrive40i', 'xDrive50i', 'M50i', 'M60i xDrive', 'Alpina XB7'] }
      ]
    },
    'Z4': {
      'Roadster': [
        { chassis: 'E89', label: 'E89', years: [2009, 2016], trims: ['sDrive18i', 'sDrive20i', 'sDrive23i', 'sDrive28i', 'sDrive30i', 'sDrive35i', 'sDrive35is'] },
        { chassis: 'G29', label: 'G29', years: [2019, 2025], trims: ['sDrive20i', 'sDrive30i', 'M40i'] }
      ]
    }
  };

  var SERIES_SEARCH_TERMS = {
    '1 Series': '1 series',
    '2 Series': '2 series',
    '3 Series': '3 series',
    '4 Series': '4 series',
    '5 Series': '5 series',
    '6 Series': '6 series',
    '7 Series': '7 series',
    '8 Series': '8 series',
    'X1': 'x1', 'X2': 'x2', 'X3': 'x3', 'X4': 'x4',
    'X5': 'x5', 'X6': 'x6', 'X7': 'x7', 'Z4': 'z4'
  };

  function inRange(year, range) { return year >= range[0] && year <= range[1]; }

  function getSeriesForYear(year) {
    return Object.keys(FITMENT).filter(function (s) {
      return Object.keys(FITMENT[s]).some(function (b) {
        return FITMENT[s][b].some(function (v) { return inRange(year, v.years); });
      });
    });
  }

  function getBodyStylesForYear(series, year) {
    if (!FITMENT[series]) return [];
    return Object.keys(FITMENT[series]).filter(function (b) {
      return FITMENT[series][b].some(function (v) { return inRange(year, v.years); });
    });
  }

  function getVariants(series, body, year) {
    if (!FITMENT[series] || !FITMENT[series][body]) return [];
    return FITMENT[series][body].filter(function (v) { return inRange(year, v.years); });
  }

  function getTrims(series, body, chassis) {
    if (!FITMENT[series] || !FITMENT[series][body]) return [];
    var v = FITMENT[series][body].filter(function (v) { return v.chassis === chassis; })[0];
    return v ? v.trims : [];
  }

  var LS_KEY = 'excella_vehicle';
  function saveVehicle(d) { try { localStorage.setItem(LS_KEY, JSON.stringify(d)); } catch (e) {} }
  function loadVehicle() { try { return JSON.parse(localStorage.getItem(LS_KEY)); } catch (e) { return null; } }
  function clearVehicle() { try { localStorage.removeItem(LS_KEY); } catch (e) {} }

  function vehicleLabel(year, series, chassis, trim) {
    var parts = [year, 'BMW', series, '(' + chassis + ')'];
    if (trim) parts.push('– ' + trim);
    return parts.join(' ');
  }

  function populate(sel, items, placeholder, vk, lk) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    items.forEach(function (item) {
      var o = document.createElement('option');
      o.value = vk ? item[vk] : item;
      o.textContent = lk ? item[lk] : item;
      sel.appendChild(o);
    });
    sel.disabled = items.length === 0;
  }

  function disableFrom(all, from) {
    for (var i = from; i < all.length; i++) {
      all[i].innerHTML = '<option value="">&mdash;</option>';
      all[i].disabled = true;
    }
  }

  function renderBadge(badge, v) {
    var label = vehicleLabel(v.year, v.series, v.chassis, (v.trim && v.trim !== '__skip__') ? v.trim : '');
    badge.innerHTML =
      '<span class="evb-dot"></span>' +
      '<span class="evb-label">Shopping for:</span>' +
      '<span class="evb-vehicle">' + label + '</span>' +
      '<a href="/#fitment-selector" class="evb-change">Change Vehicle</a>' +
      '<a href="#" class="evb-clear" aria-label="Clear vehicle">&#215;</a>';
    badge.classList.add('evb--active');
    badge.querySelector('.evb-clear').addEventListener('click', function (e) {
      e.preventDefault();
      clearVehicle();
      badge.innerHTML = '';
      badge.classList.remove('evb--active');
    });
  }

  function initBadge() {
    var v = loadVehicle();
    if (!v || !v.year) return;
    var badge = document.getElementById('excella-vehicle-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'excella-vehicle-badge';
      var header = document.querySelector('header.site-header');
      if (header) header.appendChild(badge);
      else document.body.insertBefore(badge, document.body.firstChild);
    }
    renderBadge(badge, v);
  }

  function initSelector() {
    var wrap = document.getElementById('excella-fitment-selector');
    if (!wrap) return;
    var selYear    = wrap.querySelector('#ef-year');
    var selSeries  = wrap.querySelector('#ef-series');
    var selBody    = wrap.querySelector('#ef-body');
    var selChassis = wrap.querySelector('#ef-chassis');
    var selTrim    = wrap.querySelector('#ef-trim');
    var btnFind    = wrap.querySelector('#ef-find');
    var all = [selYear, selSeries, selBody, selChassis, selTrim];

    var years = [];
    for (var y = 2025; y >= 2000; y--) years.push(y);
    populate(selYear, years, 'Select Year');
    disableFrom(all, 1);
    if (btnFind) btnFind.disabled = true;

    selYear.addEventListener('change', function () {
      disableFrom(all, 1);
      if (btnFind) btnFind.disabled = true;
      var year = parseInt(this.value);
      if (!year) return;
      populate(selSeries, getSeriesForYear(year), 'Select Model');
    });

    selSeries.addEventListener('change', function () {
      disableFrom(all, 2);
      if (btnFind) btnFind.disabled = true;
      var year = parseInt(selYear.value);
      var series = this.value;
      if (!series) return;
      var bodies = getBodyStylesForYear(series, year);
      if (bodies.length === 1) {
        populate(selBody, bodies, bodies[0]);
        selBody.value = bodies[0];
        selBody.dispatchEvent(new Event('change'));
      } else {
        populate(selBody, bodies, 'Select Body Style');
      }
    });

    selBody.addEventListener('change', function () {
      disableFrom(all, 3);
      if (btnFind) btnFind.disabled = true;
      var year    = parseInt(selYear.value);
      var series  = selSeries.value;
      var body    = this.value;
      if (!body) return;
      var variants = getVariants(series, body, year);
      if (variants.length === 1) {
        populate(selChassis, [{ chassis: variants[0].chassis, label: variants[0].chassis }], variants[0].chassis, 'chassis', 'label');
        selChassis.value = variants[0].chassis;
        selChassis.dispatchEvent(new Event('change'));
      } else {
        var opts = variants.map(function (v) {
          return { chassis: v.chassis, label: v.label + ' (' + v.years[0] + '–' + v.years[1] + ')' };
        });
        populate(selChassis, opts, 'Select Chassis', 'chassis', 'label');
      }
    });

    selChassis.addEventListener('change', function () {
      selTrim.innerHTML = '<option value="">&mdash;</option>';
      selTrim.disabled = true;
      if (btnFind) btnFind.disabled = true;
      var chassis = this.value;
      if (!chassis) return;
      var trims = getTrims(selSeries.value, selBody.value, chassis);
      populate(selTrim, ['Any Trim'].concat(trims), 'Select Trim (optional)');
      selTrim.value = 'Any Trim';
      if (btnFind) btnFind.disabled = false;
    });

    selTrim.addEventListener('change', function () {
      if (btnFind) btnFind.disabled = !selChassis.value;
    });

    if (btnFind) {
      btnFind.addEventListener('click', function () {
        var year    = selYear.value;
        var series  = selSeries.value;
        var body    = selBody.value;
        var chassis = selChassis.value;
        var trim    = (selTrim.value && selTrim.value !== 'Any Trim') ? selTrim.value : '';
        if (!chassis) return;

        saveVehicle({ year: year, series: series, body: body, chassis: chassis, trim: trim || '__skip__' });

        var seriesKw = SERIES_SEARCH_TERMS[series] || series.toLowerCase();
        var q = chassis + ' ' + seriesKw + (trim ? ' ' + trim : '');
        var label = vehicleLabel(year, series, chassis, trim);

        /* Show searching state */
        var origText = btnFind.textContent;
        btnFind.textContent = 'Searching…';
        btnFind.disabled = true;

        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=1')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources &&
                           data.resources.results &&
                           data.resources.results.products;
            if (products && products.length > 0) {
              window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
            } else {
              window.location.href = '/pages/find-your-part?vehicle=' + encodeURIComponent(label);
            }
          })
          .catch(function () {
            /* Network error: fall back to search so customer isn't stranded */
            window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
          })
          ['finally'](function () {
            btnFind.textContent = origText;
            btnFind.disabled = false;
          });
      });
    }

    var saved = loadVehicle();
    if (saved && saved.year) {
      selYear.value = saved.year;
      selYear.dispatchEvent(new Event('change'));
      setTimeout(function () {
        if (!saved.series) return;
        selSeries.value = saved.series;
        selSeries.dispatchEvent(new Event('change'));
        setTimeout(function () {
          if (!saved.body) return;
          selBody.value = saved.body;
          selBody.dispatchEvent(new Event('change'));
          setTimeout(function () {
            if (!saved.chassis) return;
            selChassis.value = saved.chassis;
            selChassis.dispatchEvent(new Event('change'));
            setTimeout(function () {
              if (saved.trim && saved.trim !== '__skip__') selTrim.value = saved.trim;
            }, 60);
          }, 60);
        }, 60);
      }, 60);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBadge();
    initSelector();
  });

  window.ExcellaFitment = { loadVehicle: loadVehicle, clearVehicle: clearVehicle };
})();
